import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  logoSrc?: string;
  fallbackMerchantName: string;
}

export const MerchantLogo = ({ logoSrc, fallbackMerchantName }: Props) => {
  const [imgError, setImgError] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        height: 77,
        width: 'fit-content',
        padding: 1,
        '& img': {
          height: '80%',
        },
      }}
    >
      {logoSrc && !imgError ? (
        <img src={logoSrc} alt={`${fallbackMerchantName} logo`} onError={() => setImgError(true)} />
      ) : (
        <Typography variant="xxl" fontWeight="semibold">
          {fallbackMerchantName}
        </Typography>
      )}
    </Box>
  );
};
